
export default function TrustBadges() {
  return (
    <section className="py-12 px-6 lg:px-12 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-center justify-center gap-12">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
              <i className="ri-shield-check-line text-[#7C3AED] text-xl"></i>
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">HIPAA Compliant</div>
              <div className="text-xs text-gray-500">Secure Marketing</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
              <i className="ri-hospital-line text-[#7C3AED] text-xl"></i>
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">Healthcare Only</div>
              <div className="text-xs text-gray-500">Specialized Expertise</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
              <i className="ri-line-chart-line text-[#7C3AED] text-xl"></i>
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">Proven Results</div>
              <div className="text-xs text-gray-500">200+ Practices Grown</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
              <i className="ri-customer-service-2-line text-[#7C3AED] text-xl"></i>
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">Full Support</div>
              <div className="text-xs text-gray-500">Dedicated Team</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
